import { render, staticRenderFns } from "./RequestsOZP.vue?vue&type=template&id=f3b07458&scoped=true&"
import script from "./RequestsOZP.vue?vue&type=script&lang=js&"
export * from "./RequestsOZP.vue?vue&type=script&lang=js&"
import style0 from "./RequestsOZP.vue?vue&type=style&index=0&id=f3b07458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b07458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
